import { appDependencies } from "../AppDependencies";
import { IRequestNotify } from "./IRequestNotify";

export class NotifyService implements IRequestNotify {
    notify(messageToDisplay: any): Promise<any> {
        return appDependencies.ICanNotify.notify(messageToDisplay);
    }
}
